import { useMutation } from '@tanstack/react-query';
import { ForgotPasswordService } from '../services/ForgotPasswordService';
import type { IVerifyCodeRequest, IVerifyCodeResponse } from '../types/ForgotPassword';

export const useVerifyCode = () =>
  useMutation<IVerifyCodeResponse, unknown, IVerifyCodeRequest>({
    mutationFn: (payload) => ForgotPasswordService.verifyCode(payload),
  });
